// extracted by mini-css-extract-plugin
export var csatScore = "_m3-5";
export var header = "_m3-1";
export var panelWrapper = "_m3-2";
export var postPreview = "_m3-3";
export var rightContent = "_m3-0";
export var wrappingText = "_m3-4";